import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import ToggleButton from "../../components/ToggleButton";
import { Table } from "react-bootstrap";
import InputField from "../../components/InputField";
import SearchIcon from "@mui/icons-material/Search";
import ConfirmationModal from "../../components/ConfirmationModal";
import PaginationComponent from "../../components/PaginationComponent";
import Loader from "../../components/Loader";
import useHomeViewController from "../../viewControllers/HomeViewControllers/HomeViewController";
import i18n from "../../constants/Strings";

const Home = () => {

  const {
    isLoading,
    handleSearch,
    searchText,
    setSearchText,
    storesData,
    currentPage,
    pageSize,
    navigate,
    totalPages,
    handlePageChange,
    setToggleStatus,
    showModal,
    clickedIndex,
    handleClose,
    handleConfirm,
    handleShow,
  } = useHomeViewController();

  const text = {
    searchPlaceholder: i18n.t('home.searchPlaceholder'),
    stores: i18n.t('home.stores'),
    sNo: i18n.t('home.sNo'),
    name: i18n.t('home.name'),
    actions: i18n.t('home.actions'),
    resetPassword: i18n.t('home.resetPassword'),
    view: i18n.t('home.view'),
    createNewCredentials: i18n.t('home.createNewCredentials'),
    deactivate: i18n.t('home.deactivate'),
    activate: i18n.t('home.activate'),
    confirmMessage: i18n.t('home.confirmMessage'),
    loginCredentials: i18n.t('home.loginCredentials'),
  };

  return (
    <>
      {isLoading ? <Loader /> : (
        <>
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 navbar-search"
              onSubmit={(e) => {
                e.preventDefault();
                handleSearch();
              }}>
              <div className="d-flex justify-space-between">
                <div className="input-group">
                  <InputField
                    type="text"
                    placeholder={text.searchPlaceholder}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    icon={<SearchIcon />}
                    onIconClick={handleSearch}
                  />
                </div>
              </div>
            </form>
          </nav>
          <div className="container-fluid">
            <div className=" mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold txt-primary">{text.stores}</h6>
              </div>

              <Table responsive bordered width="100%" cellSpacing={0}>
                <thead>
                  <tr>
                    <th>{text.sNo}</th>
                    <th>{text.name}</th>

                    <th className="d-flex justify-content-center">{text.actions}</th>
                  </tr>
                </thead>
                <tbody>
                  {storesData?.map((store, index) => {
                    const serialNumber = (currentPage - 1) * pageSize + index + 1;
                    return (
                      <tr key={index}>
                        <td className="number-cell">{serialNumber} </td>
                        <td className="">{store?.sublocname ?? "-"} </td>
                        <td className="width-45">
                          <div className="d-flex justify-content-evenly mt-2">
                            {store?.backend_store_object ? (
                              <>
                                <PrimaryButton
                                  text={text.resetPassword}
                                  className="width-auto h-0 reset-btn"
                                  onClick={() =>
                                    navigate(
                                      `/store-reset-password/${store?.sid}`,
                                      {
                                        state: {
                                          storename: store?.sublocname,
                                          aom_id:
                                            store?.backend_store_object
                                              ?.approver_id,
                                          storecode: store?.subloccode,
                                          username:
                                            store?.backend_store_object?.name,
                                        },
                                      }
                                    )
                                  }
                                />
                                <div className="mt-1" key={index}>
                                  <ToggleButton
                                    toggle={
                                      store?.backend_store_object
                                        ?.are_credentials_active
                                    }
                                    setToggle={setToggleStatus}
                                    onClick={() => handleShow(index)}
                                    togglekey={index}
                                  />
                                  <ConfirmationModal
                                    confirmationMessage={`${text.confirmMessage}  ${store?.backend_store_object
                                      ?.are_credentials_active
                                      ? text.deactivate
                                      : text.activate
                                      } ${text.loginCredentials} ${store?.sublocname
                                      } ?`}
                                    confirmattionKey={index}
                                    show={showModal && clickedIndex === index}
                                    id={store?.sid}
                                    onHide={handleClose}
                                    onConfirm={() => handleConfirm(store?.sid)}
                                  />
                                </div>
                                <div>
                                  <PrimaryButton
                                    text={text.view}
                                    className="width-auto view-btn "
                                    onClick={() =>
                                      navigate(
                                        `/view-store-details/${store?.sid}`,
                                        {
                                          state: {
                                            storename: store?.sublocname,
                                            storecode: store?.subloccode,
                                            aom_id:
                                              store?.backend_store_object
                                                ?.approver_id,
                                            username:
                                              store?.backend_store_object?.name,
                                          },
                                        }
                                      )
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <PrimaryButton
                                text={text.createNewCredentials}
                                className="width-auto h-0 mb-2 create-btn"
                                onClick={() =>
                                  navigate(`/create-new/${store?.sid}`, {
                                    state: {
                                      created: true,
                                      storename: store?.sublocname,
                                      storecode: store?.subloccode,
                                      sid: store?.sid,
                                    },
                                  })
                                }
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                data={storesData?.length}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Home;
